// types
import { i18nEaiDeliveryPoints } from 'models/i18n';
import { DeliveryPointValidationArguments } from 'views/modules/Eai/DeliveryPoints/DeliveryPointDetail/DeliveryPointCharacteristics/DeliveryPointReservedCapacityCharacteristics/deliveryPointReservedCapacityGuardingValidationSchema';

// ==============================|| I18N SK DELIVERY POINTS ||============================== //

const skEaiDeliveryPoints: i18nEaiDeliveryPoints = {
  createDeliveryPointWizard: {
    title: 'Vytvorenie OOM',
    step01: 'Identifikácia OOM',
    step02: 'Rola OOM',
    save: 'Vytvoriť OOM'
  },
  deliveryPointDetail: {
    basicInfoTab: {
      title: 'Informácie o OOM'
    },
    characteristicsTab: {
      title: 'Vlastnosti',
      technicalCharacteristics: {
        title: 'Technické parametre',
        input: {
          reserved_capacity: 'Rezervovaná kapacita - odber zo siete',
          maximum_reserved_capacity:
            'Maximálna rezervovaná kapacita - odber zo siete',
          reserved_capacity_supply: 'Rezervovaná kapacita - dodávka do siete',
          maximum_reserved_capacity_supply:
            'Maximálna rezervovaná kapacita - dodávka do siete'
        },
        validation: {
          'reserved_capacity-required': 'Rezervovaná kapacita je povinná',
          'maximum_reserved_capacity-required':
            'Maximálna rezervovaná kapacita je povinná',
          'reserved_capacity-number':
            'Rezervovaná kapacita musí byť v tvare desatinného čisla',
          'reserved_capacity-number-range':
            'Rezervovaná kapacita musí byť kladné číslo',
          'maximum_reserved_capacity-number':
            'Maximálna rezervovaná kapacita musí byť v tvare desatinného čisla',
          'maximum_reserved_capacity-number-range':
            'Maximálna rezervovaná kapacita musí byť kladné číslo'
        }
      },
      reservedCapacityCharacteristics: {
        title: 'Parametre stráženia RK',
        input: {
          reserved_capacity_guard_period_start_restriction_offset:
            'Čas začiatku reštriktívnej fázy',
          reserved_capacity_guard_phase_one_reserve:
            'Rezerva pre preventívnu fázu',
          reserved_capacity_guard_phase_two_reserve:
            'Rezerva pre reštriktívnu fázu',
          reserved_capacity_guard_earliest_restriction_start_offset:
            'Najskorší čas opatrenia',
          reserved_capacity_guard_check_periodicity: 'Frekvencia stráženia',
          reserved_capacity_guard_check_algorithm: 'Typ algoritmu',
          reserved_capacity_utilization_alarm_utilization_threshold:
            'Limitná hodnota využitia RK pre alarm',
          reserved_capacity_utilization_alarm_time_threshold:
            'Časový limit dosiahnutia limitnej hodnoty RK pre alarm'
        },
        validation: {
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PERIOD_START_RESTRICTION_OFFSET_REQUIRED]:
            'Čas začiatku reštriktívnej fázy je povinný',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PERIOD_START_RESTRICTION_OFFSET_NUMBER]:
            'Čas začiatku reštriktívnej fázy musí byť v tvare celého čísla',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_ONE_RESERVE_REQUIRED]:
            'Rezerva pre preventívnu fázu je povinná',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_ONE_RESERVE_NUMBER]:
            'Rezerva pre preventívnu fázu musí byť číslo s maximálne 2 desatinnými miestami',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_ONE_RESERVE_MAX]:
            'Rezerva pre preventívnu fázu nesmie presiahnuť Rezervovanú kapacitu - odber zo siete',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_TWO_RESERVE_REQUIRED]:
            'Rezerva pre reštriktívnu fázu je povinná',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_TWO_RESERVE_NUMBER]:
            'Rezerva pre reštriktívnu fázu musí byť číslo s maximálne 2 desatinnými miestami',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_TWO_RESERVE_MAX]:
            'Rezerva pre reštriktívnu fázu nesmie presiahnuť Rezervovanú kapacitu - odber zo siete',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_EARLIEST_RESTRICTION_START_OFFSET_REQUIRED]:
            'Najskorší čas opatrenia je povinný',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_EARLIEST_RESTRICTION_START_OFFSET_NUMBER]:
            'Najskorší čas opatrenia musí byť v tvare celého čísla',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_CHECK_PERIODICITY_REQUIRED]:
            'Frekvencia stráženia je povinná',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_CHECK_ALGORITHM_REQUIRED]:
            'Typ algoritmu je povinný',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_UTILIZATION_ALARM_UTILIZATION_THRESHOLD_REQUIRED]:
            'Limitná hodnota využitia RK pre alarm je povinná',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_UTILIZATION_ALARM_UTILIZATION_THRESHOLD_NUMBER]:
            'Limitná hodnota využitia RK pre alarm musí byť v tvare celého čísla',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_UTILIZATION_ALARM_TIME_THRESHOLD_REQUIRED]:
            'Časový limit dosiahnutia limitnej hodnoty RK pre alarm je povinný',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_UTILIZATION_ALARM_TIME_THRESHOLD_NUMBER]:
            'Časový limit dosiahnutia limitnej hodnoty RK pre alarm musí byť v tvare celého čísla'
        }
      }
    },
    gdsListTab: {
      title: 'Komunikačné brány (GDS)'
    },
    assignmentsTab: {
      title: 'Priradenie OOM'
    },
    basicInfo: {
      title: 'Základné informácie',
      input: {
        DeliveryPointId: 'ID OOM',
        DeliveryPointEic: 'EIC',
        DeliveryPointRole: 'Rola',
        DeliveryPointName: 'Názov OOM',
        DeliveryPointDescription: 'Popis OOM'
      },
      validation: {
        'DeliveryPointEic-required': 'Hodnota EIC je povinná',
        'DeliveryPointEic-length': 'Dĺžka musí byť 16',
        'DeliveryPointEic-exists': 'Hodnota EIC musí byť unikátna',
        'DeliveryPointName-required': 'Názov OOM je povinný',
        'DeliveryPointName-max': 'Prekročená maximálna dĺžka',
        'DeliveryPointDescription-max': 'Prekročená maximálna dĺžka'
      }
    },
    basicAddressInfo: {
      title: 'Adresa OOM',
      input: {
        StreetName: 'Ulica',
        StreetNumber: 'Číslo súpisné',
        UnitNumber: 'Číslo orientačné',
        PostalCode: 'PSČ',
        City: 'Mesto / Obec'
      },
      validation: {
        'StreetName-required': 'Názov ulice je povinný',
        'StreetName-max': 'Prekročená maximálna dĺžka',
        'StreetNumber-required': 'Súpisné číslo je povinné',
        'StreetNumber-max': 'Prekročená maximálna dĺžka',
        'UnitNumber-max': 'Prekročená maximálna dĺžka',
        'PostalCode-required': 'PSČ je povinné',
        'PostalCode-length': 'Dĺžka musí byť 5',
        'City-required': 'Názov mesta je povinný',
        'City-max': 'Prekročená maximálna dĺžka'
      }
    },
    gdsList: {
      title: 'Zoznam zariadení',
      searchInput: 'Zadajte názov / EIC',
      create: 'Zaregistrovať GDS',
      createEntityButton: 'Zaregistrovať GDS',
      columns: {
        id: 'ID',
        name: 'Názov',
        validity: 'Platnosť',
        actions: 'Akcie'
      },
      filter: {
        validity: 'Platnosť',
        showOnlyValid: 'Platné'
      },
      input: {
        name: 'Názov',
        searchString: 'Zadajte názov',
        showOnlyValid: 'Platné'
      }
    },
    gdsDetail: {
      searchInput: 'Zadajte názov',
      createEntityButton: 'Zaregistrovať GDS',
      input: {
        id: 'ID',
        name: 'Názov',
        validity: 'Platnosť',
        actions: 'Akcie'
      },
      basicGdsInfoTab: {
        title: 'Základné informácie'
      },
      basicInfo: {
        title: 'Základné informácie',
        input: {
          id: 'GDS ID',
          name: 'Názov',
          validTo: 'Platnosť'
        }
      },
      gdsDevices: {
        title: 'Zariadenia',
        create: 'Vytvoriť',
        remove: 'Odstrániť'
      }
    },
    assignments: {
      changeAssignmentButton: 'Zmeniť priradenie',
      emsPartyName: 'Vlastník OOM',
      balanceGroupName: 'Bilančná skupina',
      validity: 'Platnosť',
      historyOfAssignments: 'História priradení',
      columns: {
        deliveryPointOwner: 'Vlastník OOM',
        balanceGroup: 'Bilančná skupina',
        mds: 'MDS',
        validity: 'Platnosť'
      }
    },
    gdsDevicesList: {
      title: '',
      id: 'Názov zariadenia',
      name: 'Typ zariadenia',
      columns: {
        DeviceId: 'Názov zariadenia',
        DeviceType: 'Typ zariadenia',
        actions: 'Akcie'
      }
    },
    mdsTab: {
      title: 'Koncové OOM',
      columns: {
        eic: 'EIC',
        id: 'ID',
        name: 'Názov OOM'
      }
    }
  },
  deliveryPointList: {
    title: 'Zoznam OOM',
    searchInput: 'Zadajte ID / EIC / názov',
    createEntityButton: 'Vytvoriť OOM',
    columns: {
      id: 'ID',
      eic: 'EIC',
      name: 'Názov',
      role: 'Rola',
      address: 'Adresa',
      actions: 'Akcie'
    },
    filter: {
      role: 'Rola'
    }
  },
  input: {
    DeliveryPointName: 'Názov OOM',
    DeliveryPointEic: 'EIC',
    DeliveryPointRole: 'Rola OOM',
    name: 'Názov'
  },
  validation: {
    'DeliveryPointName-required': 'Názov OOM je povinný',
    'DeliveryPointName-max': 'Prekročená maximálna dĺžka',
    'DeliveryPointGDSName-required': 'Názov GDS je povinný',
    'DeliveryPointGDSName-max': 'Prekročená maximálna dĺžka',
    'DeliveryPointEic-required': 'Hodnota EIC je povinná',
    'DeliveryPointEic-length': 'Dĺžka musí byť 16',
    'DeliveryPointEic-available': 'Hodnota EIC musí byť unikátna',
    'DeliveryPointRole-required': 'Rola OOM je povinná',
    'DeliveryPointRole-max': 'Prekročená maximálna dĺžka'
  },
  createGDSDialog: {
    input: {
      balancingGroupId: 'Názov bilančnej skupiny',
      marketParticipantId: 'Názov účastníka trhu'
    }
  },
  changeDPAssignmentDialog: {
    input: {
      balanceGroup: 'Bilančná Skupina',
      marketParticipant: 'Vlastník OOM',
      deliveryPoint: 'MDS'
    },
    validation: {
      'BalanceGroup-required': 'Bilančná skupina musí byť zadaná',
      'MarketParticipant-required': 'Vlastník OOM musí byť zadaný',
      'DeliveryPoint-required': 'MDS musí byť zadaný'
    }
  }
};

export default skEaiDeliveryPoints;
